module.exports = __webpack_public_path__ + "img/flag-fill.3683b4a0.svg";